// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606050200/js/" + chunkId + "." + {"44":"90bddcda","225":"1444b8b0","481":"8bdbdcaa","486":"b38da474","770":"d182f4d3"}[chunkId] + ".0.9518134851786169.chunk.js";
};